import { createIcon } from "@chakra-ui/react";

export const Hourglass = createIcon({
  displayName: "Hourglass",
  viewBox: "0 0 24 24",
  d: "M3 22.875C3 23.498 3.502 24 4.125 24h15.75c.623 0 1.125-.502 1.125-1.125s-.502-1.125-1.125-1.125H19.5v-.89c0-1.89-.75-3.704-2.086-5.04L13.59 12l3.82-3.82A7.113 7.113 0 0 0 19.5 3.14v-.89h.375c.623 0 1.125-.502 1.125-1.125S20.498 0 19.875 0H4.125C3.502 0 3 .502 3 1.125S3.502 2.25 4.125 2.25H4.5v.89c0 1.89.75 3.704 2.086 5.04L10.41 12l-3.825 3.82A7.128 7.128 0 0 0 4.5 20.86v.89h-.375c-.623 0-1.125.502-1.125 1.125zM6.942 4.5a4.885 4.885 0 0 1-.192-1.36v-.89h10.5v.89c0 .465-.066.924-.192 1.36H6.942zm8.878 12.914a4.871 4.871 0 0 1 1.43 3.445v.891H6.75v-.89c0-1.294.516-2.532 1.43-3.446L12 13.59l3.82 3.82v.005z",
  defaultProps: {
    "aria-label": "An hourglass"
  }
});

export default Hourglass;
